<template>
  <card class="card">
    <template slot="header">
      <div class="d-flex">
        <div class="mr-auto p-2"><h4 class="card-title">{{ $t('accountProps.card.title') }}</h4></div>
        <create-account-prop-btn
          v-if="$auth.can({account_props: 'create'}, 'permissions')"
          :account-id="this.$route.params.id"/>
        <base-button type="neutral" size="sm" icon round class="zi_100 ml-2" @click="fullShow = !fullShow"
                     :disabled="expandDisabled">
          <span
            :class="{'mdi_icon':true, 'mdi':true, 'mdi-18px':true, 'mdi-unfold-more-horizontal':!fullShow, 'mdi-unfold-less-horizontal':fullShow}"/>
        </base-button>
      </div>
    </template>
    <div class="row">
      <div class="col-12">
        <account-props-view :account-props="accountProps" :full-show="fullShow" :show-n="showN"/>
      </div>
    </div>
  </card>
</template>
<script>
import CreateAccountPropBtn from "./CreateAccountPropBtn";
import {mapActions, mapState} from "vuex";
import AccountPropsView from "@/components/AccountProps/AccountPropsView";

export default {
  name: "AccountAdditionalProps",
  components: {
    CreateAccountPropBtn,
    AccountPropsView,
  },
  data() {
    return {
      fullShow: false,
      expandDisabled: true,
      showN: 2
    };
  },
  computed: {
    ...mapState({
      loading: state => state.account_props.loading,
      error: state => state.account_props.error,
      accountProps: state => state.account_props.data,
    }),
  },
  methods: {
    ...mapActions(['LoadAccountProps']),
  },
  mounted() {
    this.LoadAccountProps(this.$route.params.id)
  },
  watch: {
    accountProps(value) {
      if (value.length <= this.showN) {
        this.fullShow = false;
        this.expandDisabled = true;
      } else {
        this.expandDisabled = false;
      }
    }
  }
};
</script>

<style>
</style>
